const permission = {
    allAuths: [],
    setAuths(list) {
        if (list && list.length) {
            this.allAuths = list
        } else {
            this.allAuths = JSON.parse(localStorage.getItem('allAuths'))
        }
    },
    Check(key) {
        if (key) {
            for (let i in this.allAuths) {
                if (this.allAuths[i].auth_code == key)
                    return true
            }
            return false
        }
        return true
    }
}
export default permission